


























































































































  import Vue from "vue";
  import DBMenu from "@/components/DBMenu.vue";
    
  export default Vue.extend({
    name: "DBInternals",
    components: {
      DBMenu
    },
    computed: {
      codeExample () {
        return `
void FDungeonDefinitionSpec::Define()
{
   Describe("Join Rooms", [this]()
   {
      BeforeEach([this]()
      {
          DungeonDefinition->Clear();
      });

      int NumberOfTests = 15;
      for (int Index = 0; Index < NumberOfTests; Index++)
      {
         It(FString::Printf(TEXT("should remove walls on contiguous rooms - index: %i"), Index), EAsyncExecution::TaskGraph, [this, Index]()
         {
            FTestType1Data TestData = DungeonBuilderTestDataGenerator::GetJoinRoomsTestData(Index, DungeonDefinition);

            DungeonDefinition->JoinRooms(TestData.FirstRoom, TestData.SecondRoom);

            // Check that the result is valid
            for (int32 CellIndex1 = 0; CellIndex1 < TestData.FirstRoom->GetNumCells(); CellIndex1++)
            {
               FDBRoomCellMetadata Metadata;
               if (TestData.FirstRoom->GetCellMetadata(CellIndex1, Metadata))
               {
                  bool bResult1 = TestData.ExpectedMetadata1[CellIndex1].Equals(Metadata);
                  TEST_TRUE(bResult1);
               }
            }

            for (int32 CellIndex2 = 0; CellIndex2 < TestData.SecondRoom->GetNumCells(); CellIndex2++)
            {
               FDBRoomCellMetadata Metadata;
               if (TestData.SecondRoom->GetCellMetadata(CellIndex2, Metadata))
               {
                  bool bResult2 = TestData.ExpectedMetadata2[CellIndex2].Equals(Metadata);
                  TEST_TRUE(bResult2);
               }
            }
         });
      }
   });
}`
    }
  },
  });
  